module.exports = __webpack_public_path__ + "static/media/cover_pic@3x.5f5d5fa8.png";